package com.dotdrives.web.pages.nextsteps

import com.dotdrives.model.AutomationRule
import com.dotdrives.web.ui.DotBanner
import com.dotdrives.web.ui.DotSkeleton
import react.FC
import react.Key
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.span
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

external interface AutomationRulesPanelProps : Props {
    var loading: Boolean
    var rules: List<AutomationRule>
    var error: String?
    var onRetry: () -> Unit
    var onToggle: (String, Boolean) -> Unit
    var onOpenBuilder: () -> Unit
}

/** "Automation rules" (`portal-next-steps.dc.html`): steps that create themselves. */
val AutomationRulesPanel = FC<AutomationRulesPanelProps> { props ->
    div {
        className = ClassName("ns-automation-card")
        div { className = ClassName("ns-automation-title"); +"Automation rules" }
        div { className = ClassName("ns-automation-sub"); +"Steps that create themselves — so nothing slips." }

        props.error?.let { error ->
            DotBanner { message = error; onRetry = props.onRetry; className = "ns-inline-banner" }
        }

        when {
            props.loading && props.rules.isEmpty() -> div {
                className = ClassName("ns-automation-list")
                repeat(3) { DotSkeleton { height = "48px" } }
            }
            props.error != null && props.rules.isEmpty() -> Unit
            props.rules.isEmpty() -> div {
                className = ClassName("ns-automation-sub")
                +"No automation rules yet — the first one takes about a minute to set up."
            }
            else -> div {
                className = ClassName("ns-automation-list")
                props.rules.forEach { rule ->
                    div {
                        key = rule.id.unsafeCast<Key>()
                        className = ClassName("ns-automation-item")
                        span { className = ClassName("ns-automation-icon"); ariaHidden = true; +ruleIcon(rule.name) }
                        div {
                            className = ClassName("ns-automation-copy")
                            div { className = ClassName("ns-automation-name"); +rule.name }
                            div { className = ClassName("ns-automation-rule"); +ruleActionSummary(rule) }
                        }
                        react.dom.html.ReactHTML.button {
                            type = ButtonType.buttonType
                            className = ClassName("ns-toggle" + if (rule.isEnabled) " ns-toggle-on" else "")
                            ariaLabel = "${if (rule.isEnabled) "Turn off" else "Turn on"} ${rule.name}"
                            ariaPressed = rule.isEnabled.unsafeCast<react.dom.aria.AriaPressed>()
                            onClick = { props.onToggle(rule.id, !rule.isEnabled) }
                            span { className = ClassName("ns-toggle-knob") }
                        }
                    }
                }
            }
        }

        react.dom.html.ReactHTML.button {
            type = ButtonType.buttonType
            className = ClassName("ns-new-rule-link")
            onClick = { props.onOpenBuilder() }
            +"+ New rule"
        }
    }
}
